import {EventEmitter, Injectable} from '@angular/core';
import {FacadeService} from "../shared/service-facade/facade.service";
import {
  ALLOY_JOURNEY_TOKEN_KEY,
  ALLOY_JOURNEY_TURNOFF_MOBILE,
  DOCUMENT_CAPTURE_SERVICE_KEY,
  SOCURE_NAME
} from "../shared/constants";
import {ActivatedRoute} from "@angular/router";
import {BehaviorSubject} from "rxjs";
import {DocumentCapture} from "../shared/model/document-capture.enum";
import {DeviceType} from "../shared/model/device-type";

@Injectable({
  providedIn: 'root'
})
export class ProcessService {

  public socureDocumentProcessComplete = new EventEmitter<void>();
  public alloyEvaluateProcessComplete = new EventEmitter<void>();
  public alloyDocumentVerifyProcessComplete = new EventEmitter<void>();

  public alloyJourneyProcessComplete = new EventEmitter<void>();

  public socureDocumentUuIdMap = new Map<number, string>();
  public alloyByPassEvaluationMap = new Map<number, string>();
  public alloyEntityTokenMap = new Map<number, string>();
  public alloyEvaluateOutcomeMap = new Map<number, string>();
  public alloyDocVOutcomeMap = new Map<number, string>();
  public alloyExistingCustomerMap = new Map<number, boolean>();

  public documentCaptureService$: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public documentCaptureServiceBypass$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public displayDefaultProcessingArea$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public piHasChanged: boolean = false;

  constructor(private facadeService: FacadeService) {}

  triggerSocureDocumentProcessComplete(): void {
    this.socureDocumentProcessComplete.emit();
  }

  triggerAlloyEvaluateProcessComplete(): void {
    this.alloyEvaluateProcessComplete.emit();
  }

  triggerAlloyDocumentVerifyProcessComplete(): void {
    this.alloyDocumentVerifyProcessComplete.emit();
  }

  triggerAlloyJourneyProcessComplete(): void {
    this.alloyJourneyProcessComplete.emit();
  }

  public setDocumentCaptureService() {
    const applicationLogRequest = this.facadeService.getShoppingCartApplicationLogsRequest();

    // If this value has never been set before - lets define it based on the settings.
    if (!applicationLogRequest.journeyToken) {
      const journeyToken = this.facadeService.getStorageItem(ALLOY_JOURNEY_TOKEN_KEY);

      applicationLogRequest.journeyToken = journeyToken ?? "N/A";

      this.facadeService.setShoppingCartApplicationLogsRequest(applicationLogRequest);
    }

    if (applicationLogRequest.journeyToken === 'N/A')
      this.documentCaptureService$.next(DocumentCapture.Socure);
    else
      this.documentCaptureService$.next(DocumentCapture.Alloy);
  }
}
